import React, {useState} from 'react';
import cl from './CountriesPage.module.css';
import CountriesSubPage from "./CountriesSubPage";
import CountriesPageMenuItem from "./CountriesPageMenuItem";
import {Divider} from "@mui/material";
import RegionsSubPage from "./RegionsSubPage";
import CitiesSubPage from "./CitiesSubPage";

const subPages = [
    {title: "Страны", SubPageComponent: CountriesSubPage},
    {title: "Регионы", SubPageComponent: RegionsSubPage},
    {title: "Города", SubPageComponent: CitiesSubPage}
];

const CountriesPage = ({isAddSubMode}) => {

    const [currentSubPage, setCurrentSubPage] = useState(subPages[0]);

    const CurrentSubPageComponent = currentSubPage.SubPageComponent;

    return (
        <div className={cl.main}>
            <div className={cl.menu}>
                {subPages.map(item => (
                    <CountriesPageMenuItem
                        key={item.title}
                        title={item.title}
                        selected={item === currentSubPage}
                        onClick={() => setCurrentSubPage(item)}
                    />
                ))}
            </div>
            <Divider sx={{margin: "0 10px"}}/>
            <div className={cl.workArea}>
                <CurrentSubPageComponent isAddSubMode={isAddSubMode}/>
            </div>
        </div>
    );
};

export default CountriesPage;